import React, { useState, useEffect, useRef } from 'react'
import { Button, FormControl, Form, Col, Row } from 'react-bootstrap'
import { FetchCreateCustomer } from '../../fetcher'
import AlertMessage from '../presentational-components/AlertMessage'
import { ModalComponent } from '../presentational-components/ModalComponent'
import EnumValueTranslations from '../presentational-components/EnumValueTranslations'


const NewCustomer = ({ openAlert, handleCloseModal, salutations, setContactId = null }) => {

    const [shippingOption, setShippingOption] = useState(false)
    const [inputValues, setInputValues] = useState({
        phone: "", mail: "", salutation: {Salutation: "default", SalutationEnum: 0}, name: "", surname: ""
    })
    const [inputValuesShipping, setInputValuesShipping] = useState({
        salutationShipping: {Salutation: "default", SalutationEnum: 0}, nameShipping: "", surnameShipping: "",
        streetShipping: "", housenumberShipping: "", firstAdditionalLineShipping: "", secondAdditionalLineShipping: "", postalShipping: "", cityShipping: "", countryShipping: "Deutschland"
    })

    const handleSubmit = (e) => {
        e.preventDefault()

        let contactModel = {
            Phone: inputValues.phone,
            Email: inputValues.mail,
            SalutationContact: inputValues.salutation,
            NameContact: inputValues.name,
            SurnameContact: inputValues.surname,
            ShippingOption: 0,
        }

        if (shippingOption) {
            contactModel.ShippingOption = 1
            contactModel["SalutationShipping"] = inputValuesShipping.salutationShipping
            contactModel["NameShipping"] = inputValuesShipping.nameShipping
            contactModel["SurnameShipping"] = inputValuesShipping.surnameShipping
            contactModel["Street"] = inputValuesShipping.streetShipping
            contactModel["HouseNumber"] = inputValuesShipping.housenumberShipping

            let additionalLinesTemp = []
            if (inputValuesShipping.firstAdditionalLineShipping)
                additionalLinesTemp.push(inputValuesShipping.firstAdditionalLineShipping)
            if (inputValuesShipping.secondAdditionalLineShipping)
                additionalLinesTemp.push(inputValuesShipping.secondAdditionalLineShipping)

            contactModel["AdditionalLines"] = additionalLinesTemp
            contactModel["PostalCode"] = inputValuesShipping.postalShipping
            contactModel["City"] = inputValuesShipping.cityShipping
            contactModel["Country"] = inputValuesShipping.countryShipping
        }

        const form = e.currentTarget
        console.log("onSubmitValidity", form, form.checkValidity())
        if (form.checkValidity() === false || validPhone === false || validMail === false) {
            e.preventDefault()
            e.stopPropagation()
        } else
            if (shippingOption && (inputValuesShipping.nameShipping.length === 0 || inputValuesShipping.surnameShipping.length === 0 || inputValuesShipping.cityShipping.length === 0 || inputValuesShipping.countryShipping.length === 0 || inputValuesShipping.postalShipping.length === 0 || inputValuesShipping.streetShipping.length === 0 || inputValuesShipping.housenumberShipping.length === 0)) {
                e.preventDefault()
                e.stopPropagation()
        } else {
            console.log("CreateCustomer: ", contactModel)
            FetchCreateCustomer(contactModel, setContactId, handleCloseModal, openAlert)
        }
    }

    const [phoneValidationMessage, setPhoneValidationMessage] = useState("Bitte geben Sie eine valide E-Mail Adresse oder Telefonnummer an.")
    const [mailValidationMessage, setMailValidationMessage] = useState("")

    const [validPhone, setValidPhone] = useState(false)
    const [validMail, setValidMail] = useState(false)
    useEffect(() => {
        if (inputValues.phone === "" && inputValues.mail === "") {
            setValidPhone(false)
            setValidMail(false)
            setPhoneValidationMessage("Bitte geben Sie eine valide E-Mail Adresse oder Telefonnummer an.")
            setMailValidationMessage("")
        } else {
            if (inputValues.phone !== "") {
                let phoneValidation = (/^[0-9]{8,}/).test(inputValues.phone)
                setValidPhone(phoneValidation)
                if (!phoneValidation) setPhoneValidationMessage("Bitte geben Sie eine valide Telefonnummer (ohne Zusatzzeichen, mind. 8 Ziffern) an.")
            } else setValidPhone(true)
            if (inputValues.mail !== "") {
                let mailValidation = (/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i).test(inputValues.mail)
                setValidMail(mailValidation)
                if (!mailValidation) setMailValidationMessage("Bitte geben Sie eine valide E-Mail Adresse an.")
            } else setValidMail(true)
        }
    }, [inputValues.phone, inputValues.mail])

    const onChangeSalutation = (e) => {
        e.preventDefault()
        let newSalutation = (salutations[e.target.selectedIndex])
        if (inputValuesShipping.salutationShipping === "Anrede" || inputValuesShipping.salutationShipping.Salutation === inputValues.salutation.Salutation)
            setInputValuesShipping({ ...inputValuesShipping, ["salutationShipping"]: newSalutation })
        setInputValues({ ...inputValues, ["salutation"]: newSalutation })
    }

    const onChangeName = (e) => {
        e.preventDefault()
        let newName = e.target.value
        if (inputValuesShipping.nameShipping === "" || inputValuesShipping.nameShipping === inputValues.name)
            setInputValuesShipping({ ...inputValuesShipping, ["nameShipping"]: newName })
        setInputValues({ ...inputValues, ["name"]: newName })
    }

    const onChangeSurname = (e) => {
        e.preventDefault()
        let newSurname = e.target.value
        if (inputValuesShipping.surnameShipping === "" || inputValuesShipping.surnameShipping === inputValues.surname)
            setInputValuesShipping({ ...inputValuesShipping, ["surnameShipping"]: newSurname })
        setInputValues({ ...inputValues, ["surname"]: newSurname })
    }

    const showShippingOptions = () => {
        return (
            <>
                <Form.Label className="controlTitleHeader">Lieferanschrift</Form.Label>

                <Row className="mb-3">
                    <Form.Group as={Col} controlId="customGroup02-01">
                        <Form.Label>Anrede:</Form.Label>
                        <Form.Control as="select" value={EnumValueTranslations(inputValuesShipping.salutationShipping.Salutation)}
                            focusFirstItemOnShow='keyboard' onChange={(e) => setInputValuesShipping({ ...inputValuesShipping, ["salutationShipping"]: (salutations[e.target.selectedIndex]) })}>
                            <option disabled value="default">Anrede</option>
                            {salutations.filter(entry => entry.Salutation != "NA").map((entry, index) =>
                                <option>{EnumValueTranslations(entry.Salutation)}</option>)
                            }
                        </Form.Control>
                    </Form.Group>

                    <Form.Group as={Col} controlId="customGroup02-02">
                        <Form.Label className="controlTitle">Name:</Form.Label>
                        <Form.Control isInvalid={shippingOption && inputValuesShipping.nameShipping.length === 0} as="input" value={inputValuesShipping.nameShipping} onChange={(e) => setInputValuesShipping({ ...inputValuesShipping, ["nameShipping"]: e.target.value })} defaultValue={inputValues.name}></Form.Control>
                    </Form.Group>

                    <Form.Group as={Col} controlId="customGroup02-03">
                        <Form.Label className="controlTitle">Vorname:</Form.Label>
                        <Form.Control isInvalid={shippingOption && inputValuesShipping.surnameShipping.length === 0} as="input" value={inputValuesShipping.surnameShipping} onChange={(e) => setInputValuesShipping({ ...inputValuesShipping, ["surnameShipping"]: e.target.value })} defaultValue={inputValues.surname}></Form.Control>
                    </Form.Group>
                </Row>

                <Row className="mb-3">
                    <Form.Group as={Col} controlId="customGroup02-04">
                        <Form.Label className="controlTitle">Straße:</Form.Label>
                        <Form.Control isInvalid={shippingOption && inputValuesShipping.streetShipping.length === 0} as="input" value={inputValuesShipping.streetShipping} onChange={(e) => setInputValuesShipping({ ...inputValuesShipping, ["streetShipping"]: e.target.value })}></Form.Control>
                    </Form.Group>

                    <Form.Group as={Col} controlId="customGroup02-05">
                        <Form.Label className="controlTitle">Hausnummer:</Form.Label>
                        <Form.Control isInvalid={shippingOption && inputValuesShipping.housenumberShipping.length === 0} as="input" value={inputValuesShipping.housenumberShipping} onChange={(e) => setInputValuesShipping({ ...inputValuesShipping, ["housenumberShipping"]: e.target.value })}></Form.Control>
                    </Form.Group>
                </Row>

                <Row className="mb-3">
                    <Form.Group as={Col} controlId="customGroup02-06">
                        <Form.Label>Zusatz 1:</Form.Label>
                        <Form.Control as="input" value={inputValuesShipping.firstAdditionalLineShipping} onChange={(e) => setInputValuesShipping({ ...inputValuesShipping, ["firstAdditionalLineShipping"]: e.target.value })}></Form.Control>
                    </Form.Group>
                </Row>

                <Row className="mb-3">
                    <Form.Group as={Col} controlId="customGroup02-07">
                        <Form.Label>Zusatz 2:</Form.Label>
                        <Form.Control as="input" value={inputValuesShipping.secondAdditionalLineShipping} onChange={(e) => setInputValuesShipping({ ...inputValuesShipping, ["secondAdditionalLineShipping"]: e.target.value })}></Form.Control>
                    </Form.Group>
                </Row>

                <Row className="mb-3">
                    <Form.Group as={Col} controlId="customGroup02-08">
                        <Form.Label className="controlTitle">PLZ:</Form.Label>
                        <Form.Control as="input" isInvalid={shippingOption && inputValuesShipping.postalShipping.length === 0} value={inputValuesShipping.postalShipping} onChange={(e) => setInputValuesShipping({ ...inputValuesShipping, ["postalShipping"]: e.target.value })}></Form.Control>
                    </Form.Group>

                    <Form.Group as={Col} controlId="customGroup02-09">
                        <Form.Label className="controlTitle">Stadt:</Form.Label>
                        <Form.Control as="input" isInvalid={shippingOption && inputValuesShipping.cityShipping.length === 0} value={inputValuesShipping.cityShipping} onChange={(e) => setInputValuesShipping({ ...inputValuesShipping, ["cityShipping"]: e.target.value })}></Form.Control>
                    </Form.Group>
                </Row>

                <Row className="mb-3">
                    <Form.Group as={Col} controlId="customGroup02-10">
                        <Form.Label className="controlTitle">Land:</Form.Label>
                        <Form.Control as="input" isInvalid={shippingOption && inputValuesShipping.countryShipping.length === 0} value={inputValuesShipping.countryShipping} onChange={(e) => setInputValuesShipping({ ...inputValuesShipping, ["countryShipping"]: e.target.value })}></Form.Control>
                    </Form.Group>
                </Row>
            </>
        )
    }

    return (
        <div lang="de">
            <Form noValidate onSubmit={handleSubmit} id='create-customer-form'>
                <Form.Group controlId="article-select">
                    <Form.Label className="controlTitleHeader">Kontaktdaten für Abholung oder Versand</Form.Label>

                    <Row className="mb-3">
                        <Form.Group as={Col} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">Telefonnummer:</Form.Label>
                            <Form.Control isValid={validPhone} isInvalid={!validPhone} as="input" value={inputValues.phone} onChange={(e) => setInputValues({ ...inputValues, ["phone"]: e.target.value })}></Form.Control>
                            <Form.Control.Feedback type="invalid">
                                {phoneValidationMessage}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group as={Col} controlId="customGroup01-02">
                            <Form.Label className="controlTitle">und/oder</Form.Label>
                        </Form.Group>

                        <Form.Group as={Col} controlId="customGroup01-03">
                            <Form.Label className="controlTitle">E-Mail Adresse:</Form.Label>
                            <Form.Control isValid={validMail} isInvalid={!validMail} as="input" value={inputValues.mail} onChange={(e) => setInputValues({ ...inputValues, ["mail"]: e.target.value })}></Form.Control>
                            <Form.Control.Feedback type="invalid">
                                {mailValidationMessage}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col} controlId="customGroup01-04">
                            <Form.Label>Anrede:</Form.Label>
                            <Form.Control as="select" value={EnumValueTranslations(inputValues.salutation.Salutation)}
                                focusFirstItemOnShow='keyboard' onChange={onChangeSalutation}>
                                <option disabled value="default">Anrede</option>
                                {salutations.filter(entry => entry.Salutation != "NA").map(entry =>
                                    <option>{EnumValueTranslations(entry.Salutation)}</option>)
                                }
                            </Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} controlId="customGroup01-05">
                            <Form.Label>Name:</Form.Label>
                            <Form.Control as="input" value={inputValues.name} onChange={onChangeName}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} controlId="customGroup01-06">
                            <Form.Label>Vorname:</Form.Label>
                            <Form.Control as="input" value={inputValues.surname} onChange={onChangeSurname}></Form.Control>
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col} controlId="customGroup01-07">
                            <Form.Check id="checkbox1" type="checkbox" label="Lieferadresse für Versand hinzufügen"
                                checked={shippingOption} onChange={(e) => setShippingOption(e.target.checked)} />
                        </Form.Group>
                    </Row>

                    {shippingOption && showShippingOptions()}
                    
                </Form.Group>
            </Form>
        </div>
    );
}

export { NewCustomer }